import apiService from "../api";

export const createHealthFacility = (formData: Record<string, any>) => {
  return apiService("/healthfacilities/create/", "POST", formData, true, {
    "Content-Type": "multipart/form-data",
  });
};
